import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import Loader from "../components/Loader";
import { useForgotPasswordMutation } from "../slices/usersApiSlice";

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState("");
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const submitHandler = async (e) => {
    e.preventDefault();
    const normalized = String(email || "").trim().toLowerCase();
    if (!normalized || !/^\S+@\S+\.\S+$/.test(normalized)) {
      toast.error("Enter a valid email address");
      return;
    }

    try {
      const res = await forgotPassword(normalized).unwrap();
      toast.success(res?.message || "If your email exists, a reset link has been sent.");
    } catch (err) {
      toast.error(err?.data?.message || err?.error || "Could not process request");
    }
  };

  return (
    <section className="mx-auto w-full max-w-md">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">
          Account
        </p>
        <h1 className="mb-3 text-3xl font-semibold text-slate-900">Forgot Password</h1>
        <p className="mb-4 text-sm text-slate-600">
          Enter your email to receive a password reset link.
        </p>

        <form onSubmit={submitHandler} className="space-y-4">
          <div>
            <label htmlFor="forgotEmail" className="mb-1.5 block text-sm font-medium text-slate-700">
              Email Address
            </label>
            <input
              id="forgotEmail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email"
              className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm text-slate-800 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-2 focus:ring-sky-100"
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="inline-flex items-center justify-center rounded-xl bg-sky-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-sky-700 disabled:cursor-not-allowed disabled:bg-slate-300"
          >
            Send reset link
          </button>
          {isLoading ? <Loader /> : null}
        </form>

        <p className="mt-5 text-sm text-slate-600">
          Remembered your password?{" "}
          <Link to="/login" className="font-semibold text-sky-700 no-underline hover:text-sky-800">
            Sign In
          </Link>
        </p>
      </div>
    </section>
  );
};

export default ForgotPasswordScreen;
